import Snackbar from '@/components/global/snackbar'

export default {
    data: () => ({
        snackbar: {
            color: 'success',
            text: '',
            display: false
        },
    }),
    components: {
        Snackbar
    }
}
